function humanizeEnum(value) {
  if (value == null || value === '') return '';
  return String(value)
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function lineNumber(original) {
  const value = original?.lineNumber;
  if (value == null) return '';
  return value;
}

function importRecordRaw(original) {
  const raw = original?.importRecordRaw;
  if (raw == null) return '';

  return JSON.stringify(raw);
}

function recordStatus(original) {
  return humanizeEnum(original?.recordStatus);
}

function failedReason(original) {
  return original?.failedReason || '';
}

export { lineNumber, importRecordRaw, recordStatus, failedReason };
